import AcknowledgeIssue from "./hooks/acknowledge_issue";
import AudioMp3 from "./hooks/audio_mp3";
import { DonutChartHook } from "./hooks/chart";
import ClearInput from "./hooks/clear_input";
import { Clock, ItemTimer, Timer } from "./hooks/clocks";
import { DragAndDropSortable } from "./hooks/drag_and_drop_sortable";
import { ElementSize } from "./hooks/element_size";
import Flash from "./hooks/flash";
import GoogleMap from "./hooks/google_map";
import PlaceAutoComplete from "./hooks/google_place_autocomplete";
import PreserveProductForm from "./hooks/preserve_product_form";
import RememberedParams from "./hooks/remembered_params";
import InfiniteScroll from "./hooks/infinite_scroll";
import InternationalPhoneNumber from "./hooks/international_phone_number";
import Modal from "./hooks/modal";
import PushEvent from "./hooks/push_event";
import ScrollTo from "./hooks/scroll_to";
import SearchableMultiSelect from "./hooks/searchable_multi_select";
import SearchableSelect from "./hooks/searchable_select";
import SelectOnFocus from "./hooks/select_on_focus";
import SocketDisconnect from "./hooks/socket_disconnect";
import {
  StripeBankAccountForm,
  StripePaymentForm,
} from "./hooks/stripe_elements";

const Hooks = {
  AcknowledgeIssue,
  AudioMp3,
  ClearInput,
  Clock,
  DonutChartHook,
  ElementSize,
  Flash,
  GoogleMap,
  InfiniteScroll,
  InternationalPhoneNumber,
  ItemTimer,
  Modal,
  PlaceAutoComplete,
  PreserveProductForm,
  PushEvent,
  RememberedParams,
  ScrollTo,
  SearchableMultiSelect,
  SearchableSelect,
  SelectOnFocus,
  SocketDisconnect,
  DragAndDropSortable,
  StripeBankAccountForm,
  StripePaymentForm,
  Timer,
};

export default Hooks;
